import React from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import ProgressRing from '@adsk/alloy-react-progress-ring';

import { useTranslation } from '../i18n';

const EntityPickerModalLoadMoreLoader = () => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" height="68px" paddingLeft="50px">
      <ProgressRing
        size={ProgressRing.SIZES.SMALL}
        style={{ margin: '5px 0' }}
      />
      <Text typography="bodySmall" color="charcoal700" marginLeft="13px">
        {t('LOADING_MORE_RESULTS')}
      </Text>
    </Flex>
  );
};

export default EntityPickerModalLoadMoreLoader;
